/*
 * Class for handling file storage in S3
 * constructor:
 * S3_BUCKET - Target bucket found in env variables
 * S3_KEY - Key for encryption provided by backend
 * COGNITO_REGION - Bucket region
 * COGNITO_IDENTITY_POOL_ID - Pool ID
 * COGNITO_USER_POOL_ID - User pool ID
 * authenticator - cognito link
 */

import AWS from "aws-sdk";

export default class S3_Handler {
  constructor() {
    this.S3_BUCKET = process.env.VUE_APP_S3_BUCKET;
    this.S3_REGION = process.env.VUE_APP_S3_REGION;
    this.S3_IDENTITY_POOL_ID = process.env.VUE_APP_S3_IDENTITY_POOL_ID;
    this.accessKeyId = process.env.VUE_APP_AWS_ACCESS_KEY_ID;
    this.secretAccessKey = process.env.VUE_APP_AWS_SECRET_ACCESS_KEY;
    // this.S3_KEY = process.env.VUE_APP_S3_KEY;
    // this.COGNITO_USER_POOL_ID = process.env.VUE_APP_COGNITO_USER_POOL_ID;
    // this.authenticator = "";
  }

  S3Config() {
    // AWS Config
    // this.authenticator = `cognito-idp.${this.COGNITO_REGION}.amazonaws.com/${
    //   this.COGNITO_USER_POOL_ID
    // }`;
    AWS.config.update({
      region: this.S3_REGION,
      accessKeyId: this.accessKeyId,
      secretAccessKey: this.secretAccessKey
      // credentials: new AWS.CognitoIdentityCredentials({
      //   IdentityPoolId: this.S3_IDENTITY_POOL_ID
      // })
    });
    // S3 Config
    let s3 = new AWS.S3({
      params: {
        Bucket: this.S3_BUCKET
      }
    });
    return s3;
  }

  getBucketName () {
    return this.S3_BUCKET;
  }
  getS3KeyFromUrl (S3Url) {
    const s3Domain = `https://${this.S3_BUCKET}`;
    let src = '';

    if (S3Url.startsWith(s3Domain)) {
      src = S3Url.replace(`https://${this.S3_BUCKET}.s3.${this.S3_REGION}.amazonaws.com/`, '')
    }

    return src;
  }
  // fileToBlob(file) {
  //   // Convert PDF file to blob so it can be handled by app
  //   return new Blob([file], { type: "application/pdf" });
  // }
  async uploadFileP(filename, file, check) {
    const s3 = this.S3Config();
    try
        {

        if(check==true)
        {
        const upload = s3
          .upload({
            Key: filename,
            Body: file,
            ACL: "public-read",
            ContentType: file.type
          })
          .promise();

          const response = await upload;
          return response;
        }
        else{
          const upload = s3
          .upload({
            Key: filename,
            Body: file,
            ContentType: file.type
          })
          .promise();

          const response = await upload;
          return response;
        }


        }
        catch (error) {
          console.log(error);

          throw error.response;
        }
  }

  async uploadFile(filename, file) {
    const s3 = this.S3Config();
    // Upload File to S3
    try {
      // let upload = s3
      // .upload({
      //   Key: filename,
      //   Body: file,
      //   ACL: "authenticated-read",
      //   SSECustomerAlgorithm: "AES256",
      //   SSECustomerKey: this.S3_KEY,
      //   ContentType: "application/pdf"
      // })
      // const name = `${Date.now()}.${filename.split(".").pop()}`;
      const upload = s3
        .upload({
          Key: filename,
          Body: file
        })
        .promise();

      const response = await upload;

      return response;
    } catch (error) {
      console.log(error);

      throw error.response;
    }
  }
  // async fetchFile(filename) {
  //   let s3 = this.S3Config();
  //   // Get file from S3
  //   try {
  //     let fetch = s3
  //       .getObject({
  //         Key: filename,
  //         SSECustomerAlgorithm: "AES256",
  //         SSECustomerKey: this.S3_KEY,
  //         ResponseContentType: "application/pdf"
  //       })
  //       .promise();
  //     let response = await fetch;
  //     let file = this.fileToBlob(response.Body);
  //     return new ReturnState(200, "sucess", file);
  //   } catch (error) {
  //     throw new ReturnState(500, "error", error);
  //   }
  // }
  getSignedUrl(url = "", expTime = 900) {
    const s3 = this.S3Config();

    // remove access through cognito identity pool
    s3.config.accessKeyId = process.env.VUE_APP_AWS_ACCESS_KEY_ID;
    s3.config.secretAccessKey = process.env.VUE_APP_AWS_SECRET_ACCESS_KEY;

    const prefix = `https://${this.S3_BUCKET}.s3.ca-central-1.amazonaws.com/`;
    const key = url.replace(prefix, "");

    const signedUrl = s3.getSignedUrl("getObject", {
      Bucket: this.S3_BUCKET,
      Key: key,
      Expires: expTime
    });
    return signedUrl;
  }

  signS3LinksFromText(source) {
    const pattern =
      "(https://[a-z0-9][a-z0-9-.]*.s3.[a-z0-9-.]*.amazonaws.com/.*(jpg|png|gif|jpeg|pdf|JPG|JPEG|PNG))";
    const url = source.match(pattern);
    if (url) return this.getSignedUrl(url[0]);
  }

  async uploadMediaFile(filename, file, contentType) {
    this.S3Config();

    const s3 = new AWS.S3({
      params: {
        Bucket: process.env.VUE_APP_S3_MEDIA_BUCKET
      }
    });

    try {
      const upload = s3
        .upload({
          Key: filename,
          Body: file,
          ContentType: contentType
        })
        .promise();

      const response = await upload;

      return response;
    } catch (error) {
      console.log(error);
      throw error.response;
    }
  }
}
